module.exports = __webpack_public_path__ + "static/profile-7109c08fb58f843fadda2b26d30594cf.jpg";